<H1> Frequency<app-loader [status]="loaderStatus"></app-loader></H1>

<div *ngFor='let in of counter(207) ;let i = index'>
    <app-frequencydetails [refNumber] = "i" ></app-frequencydetails>
</div>



